import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";

export default function mount(Component, context = {}, documentId = "root") {
    Object.assign(window.initial.context, context);
    ReactDOM.render(<Component {...window.initial} />, document.getElementById(documentId));
}
